<div class="row">
  <div class="col">
    <div class="section-header mb-4">
      <h1 class="h4">Solicitud de Reembolso</h1>
    </div>
  </div>
</div>

<div class="row justify-content-center">
  <div class="col-12 col-md-10 col-xxl-6">
    <div class="row">
      <div class="col">
        <div class="card">
          @if (!isIntermediary || idNumber) {
            <div class="card-header">
              <h4 class="fs-5 text-colonial">
                {{
                  activeStep == 3
                    ? "Reembolso solicitado exitosamente"
                    : "Completa la información"
                }}
              </h4>

              <div class="mb-3">
                <ngb-progressbar
                  [value]="progressValue"
                  class="mb-3"
                  type=""
                ></ngb-progressbar>
                <small class="text-muted">Paso {{ activeStep }} de 3</small>
              </div>

              <div class="d-flex flex-column flex-md-row gap-3">
                <div>
                  <strong>Póliza: </strong>
                  <span>{{
                    insuredHolder?.policyNumber || "No disponible"
                      | mask: policyMask
                  }}</span>
                </div>
                <div>
                  <strong>Carnet: </strong>
                  <span>{{
                    insuredHolder?.referenceNumber || "No disponible"
                  }}</span>
                </div>
                @if (insuredSelected) {
                  <div>
                    <strong>Asegurado: </strong>
                    <span>{{ insuredSelected.name || "No disponible" }}</span>
                  </div>
                }
              </div>
            </div>
          }

          <div class="card-body">
            @if (isIntermediary && !idNumber) {
              <div
                class="d-flex flex-column align-items-center justify-content-center gap-2"
              >
                <span class="material-symbols-outlined"> report </span>
                <label>No se pudo encontrar el cliente</label>
              </div>
            } @else {
              @if (activeStep === 1) {
                <app-insured-step
                  (onInsuredSelected)="onInsuredSelected($event)"
                  (nextStep)="nextStep()"
                  (onGoBack)="onBackPressed()"
                  [insuredList]="insuredList"
                ></app-insured-step>
              } @else if (activeStep === 2 && insuredSelected) {
                <app-claim-request-form-step
                  [idNumber]="idNumber"
                  (nextStep)="nextStep()"
                  (onGoBack)="onBackPressed()"
                  [insuredSelected]="insuredSelected"
                  [insuredHolder]="insuredHolder"
                  (onFormCompleted)="onFormCompleted($event)"
                ></app-claim-request-form-step>
              } @else if (activeStep === 3) {
                <app-claim-request-rate
                  [claimRequestId]="claimRequestId"
                ></app-claim-request-rate>
              }
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
